export default class vendorPaymentsInstamojo {
  constructor() {
    $(".instamojo").on("click", this.generateInstamojoAccessToken);
  }

  generateInstamojoAccessToken = async () => {
    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/InstamojoPayments/generateAccessToken",
        type: "GET",
        success: (result) => {
          result = JSON.parse(result);
          this.createPaymentRequest(result.access_token);
          resolve();
        },
        error: (result) => {
          try {
            result = JSON.parse(result);
          } catch (e) {}
          resolve();
        },
      });
    });
  };

  createPaymentRequest = (access_token) => {
    $.ajax({
      url: baseURL + "api/InstamojoPayments/createPaymentRequest",
      type: "POST",
      data: {
        Access_Token: `Bearer ${access_token}`,
        Vendor_ID: "67ccb451-4497-11e9-b548-778fd1e3dff0",
        Amount: "100",
        Payment_Type: "Sponsored Payment",
      },
      success: (result) => {
        result = JSON.parse(result);

        // Simulate an HTTP redirect:
        window.location.replace(result.longurl);
        //const paymentSessionId = result["payment_session_id"];
        //const cf = new Cashfree(paymentSessionId, dropConfig);
        //cf.redirect();
      },
      error: (result) => {
        try {
          result = JSON.parse(result);
        } catch (e) {}
      },
    });
  };
}

